import React from 'react';
import PropTypes from 'prop-types';

import LazyLoadTransition from '../../../components/LazyLoadTransition/LazyLoadTransition';
import './SponsorsPart.css';

const SponsorPart = ({ imgs, title }) => (
    <div className="container">
        <LazyLoadTransition>
            <h1 className="section-title">{title}</h1>
            <div className="columns is-variable is-mobile is-multiline">
                {imgs.map(({ alt, styles, url, src, imgHeight, imgHeightMobile }) => (
                    <div
                        className={`column is-desktop-3 ${styles}`}
                        key={alt}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <a
                            href={url}
                            rel="noopener noreferrer"
                            style={{ height: '100%' }}
                            target="_blank"
                        >
                            <img
                                alt={alt}
                                className="is-hidden-mobile"
                                src={src}
                                style={{
                                    height: imgHeight,
                                    minWidth: imgHeight,
                                    top: `calc((100% - ${imgHeight})/2)`,
                                    position: 'relative'
                                }}
                            />
                            <img
                                alt={alt}
                                className="is-hidden-desktop is-hidden-tablet"
                                src={src}
                                style={{
                                    height: imgHeightMobile,
                                    minWidth: imgHeightMobile,
                                    top: `calc((100% - ${imgHeightMobile})/2)`,
                                    position: 'relative'
                                }}
                            />
                        </a>
                    </div>
                ))}
            </div>
        </LazyLoadTransition>
    </div>
);

export default SponsorPart;

SponsorPart.propTypes = {
    imgs: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
    title: PropTypes.string.isRequired
};
